/** UI languages supported by i18n resources. */
export enum AppLocale {
  En = "en",
  Hr = "hr",
}
